import type { Field } from "../../../api/types/objectTypes";

export interface TableColumnDefinition {
  id: string;
  title: string;
  dynamic?: boolean;
  defaultHidden?: boolean;
}

export const getColumnDefinitionForField = (field: Field, visible?: boolean): TableColumnDefinition => ({
  id: field.id,
  title: field.name,
  dynamic: true,
  defaultHidden: !visible,
});

export const objectTimestampsColumnIds = {
  createdAtColumnId: "_systemCreatedAt",
  modifiedAtColumnId: "_systemModifiedAt",
};

export const getColumnDeinitionsForTimestampFields = (visible?: boolean): TableColumnDefinition[] => [
  {
    id: objectTimestampsColumnIds.createdAtColumnId,
    title: "Created at",
    defaultHidden: !visible,
  },
  {
    id: objectTimestampsColumnIds.modifiedAtColumnId,
    title: "Modified at",
    defaultHidden: !visible,
  },
];
